import React, { Component } from 'react';
import PropTypes from 'prop-types';
import observeRootStore from '../../components/hoc/observeRootStore';

import Slide from '../carousel/slide';
import SROnly from '../srOnly';

import './scroller.scss';
import * as constants from '../../appConstants';

export class Scroller extends Component {
    scrollDistance = (142 + 10) * 6; // 142 is the scroll size, plust 10 for margins

    viewState = e => {
        const { rootStore } = this.props;
        const stateAbbr = e.currentTarget.dataset.state;

        rootStore.uiStore.selectedState = !rootStore.uiStore.selectedState || rootStore.uiStore.selectedState.gid !== stateAbbr ?
            rootStore.opsMapCountries[rootStore.uiStore.activeMap][stateAbbr] :
            null;
    };

    hasDealers = stateObj => {
        const selectedFilter = this.props.rootStore.uiStore.selectedFilter;
        if (stateObj.dealersCoordinates.length > 0) {
            return true;
        } else {
            return (stateObj.classList.indexOf(selectedFilter) > 0);
        }
    };

    isFiltered = stateObj => {
        const selectedFilter = this.props.rootStore.uiStore.selectedFilter;
        let filtered = false;
        if (selectedFilter !== constants.FILTER_ALL) {
            if (selectedFilter === constants.FILTER_DEALERSHIPS) {
                filtered = !this.hasDealers(stateObj);
            } else {
                filtered = (stateObj.classList.indexOf(selectedFilter) < 0);
            }
        }
        return filtered;
    };


    renderSlides(country) {
        const states = Object.keys(country).sort((a, b) => a - b).filter(state => (
            country[state].hasDetails &&
            country[state].gid !== 'USPR') &&
            !this.isFiltered(country[state])
        );


        // If activeMap is United States then add Puerto Rico to the end of the ada drawer slides
        if (this.props.rootStore.uiStore.activeMap === constants.UNITED_STATES &&
            !this.isFiltered(country['USPR'])) {
            states.push('USPR');
        }

        return states.map((gid) => (
            <Slide
                sid={gid}
                key={gid}
                data-state={gid}
                bg={country[gid].imgSrc}
                onClick={this.viewState}>
                {country[gid].state}
            </Slide>
        ));
    }

    slideLeft = () => {
        this.refs.wrapper.scrollLeft = this.refs.wrapper.scrollLeft - this.scrollDistance;
    }

    slideRight = () => {
        this.refs.wrapper.scrollLeft = this.refs.wrapper.scrollLeft + this.scrollDistance;
    }

    render() {
        const slides  = this.renderSlides(this.props.country);

        if(slides.length <= 12) {
            return (
                <div className="scroll-centered">{slides}</div>
            );
        }

        return (
            <div className="scroll-wrapper">
                <button className="scroll-indicator" onClick={this.slideLeft}>
                    <SROnly>Scroll Left</SROnly>
                </button>
                <div className="overflow-scroller" ref="wrapper">
                    {slides}
                </div>
                <button className="scroll-indicator right" onClick={this.slideRight}>
                    <SROnly>Scroll Right</SROnly>
                </button>
            </div>
        );
    }
}

Scroller.propTypes = {
    rootStore: PropTypes.shape({
        uiStore: PropTypes.shape({
            selectedState: PropTypes.object,
            activeMap: PropTypes.string.isRequired,
            selectedFilter: PropTypes.string.isRequired,
        }).isRequired,
        opsMapCountries: PropTypes.objectOf(
            PropTypes.objectOf(
                PropTypes.shape({
                    gid: PropTypes.string.isRequired,
                    hasDetails: PropTypes.bool.isRequired,
                    imgSrc: PropTypes.string,
                    state: PropTypes.string,
                    classList: PropTypes.string,
                    dealersCoordinates: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))
                })
            )
        ).isRequired,
    }).isRequired,
    country: PropTypes.objectOf(
        PropTypes.shape({
            gid: PropTypes.string.isRequired,
            hasDetails: PropTypes.bool.isRequired,
            imgSrc: PropTypes.string,
            state: PropTypes.string,
            classList: PropTypes.string,
            dealersCoordinates: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))
        })
    ).isRequired,
};

export default observeRootStore(Scroller);
